module.exports = __webpack_public_path__ + "static/media/3DPPA8.ba4f3f2e.jpg";